import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Col, Container, Row, Alert } from "reactstrap"
import { MDBDataTable } from "mdbreact"
import { Button, customInput } from "reactstrap"

import AddStaffModal from "../../components/StaffModal/AddStaffModal"
import UpdateStaffModal from "../../components/StaffModal/UpdateStaffModal"

// services
import Admin from "../../services/admin/Admin"

const adminService = new Admin()

const StaffDirectory = () => {
  const [addStaffModal, setAddStaffModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [registrationError, setRegistrationError] = useState("")
  const [registrationSuccess, setRegistrationSuccess] = useState("")

  const [updateStaffModal, setUpdateStaffModal] = useState(false)
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false)
  const [updateError, setUpdateError] = useState("")
  const [updateSuccess, setUpdateSuccess] = useState("")

  // individual staff
  const [individualStaff, setIndividualStaff] = useState({})

  // API data
  const [permissions, setPermissions] = useState({})
  const [departments, setDepartments] = useState({})
  const [positions, setPositions] = useState({})
  const [allStaff, setAllStaff] = useState([])
  const [mounted, setMounted] = useState(false)
  const [mountUpdateModal, setMountUpdateModal] = useState(false)

  useEffect(() => {
    apiReqs()
  }, [])

  useEffect(() => {
    apiReqs()
  }, [registrationSuccess])

  useEffect(() => {
    apiReqs()
  }, [updateSuccess])

  async function apiReqs() {
    var res = await adminService.getDepartments()
    setDepartments(res.data.data)
    res = await adminService.getPositions()
    setPositions(res.data)
    res = await adminService.getPermissions()
    setPermissions(res.data)

    var staffDetails = []
    res = await adminService.getAllStaff()
    res.data.forEach(staff => {
      let otherName = ""
      if (staff.other_name !== null) {
        otherName = staff.other_name
      }
      staffDetails.push({
        id: staff.id,
        departmentId: staff.department_id,
        positionId: staff.position_id,
        firstName: staff.first_name,
        lastName: staff.last_name,
        otherNames: staff.other_name,
        email: staff.email,
        phone: staff.telephone,
        isActive: staff.is_active,
        name: staff.first_name + " " + staff.last_name + " " + otherName,
        position: staff.positions.name,
        department: staff.departments.name,
        actions: (
          <form
            onSubmit={(e, v) => {
              e.preventDefault()
              const staffId = e.target[0].value
              onClickUpdate(staffId)
            }}
          >
            <input type="hidden" name="staffId" value={staff.id}></input>
            <input type="submit" value="Edit" className="btn btn-info" />
          </form>
        ),
      })
    })
    setAllStaff(staffDetails)

    setMounted(true)
  }

  const data = {
    columns: [
      {
        label: "Name",
        field: "name",
        sort: "asc",
        width: 150,
      },
      {
        label: "Position",
        field: "position",
        sort: "asc",
        width: 270,
      },
      {
        label: "Department",
        field: "department",
        sort: "asc",
        width: 200,
      },
      {
        label: "Email",
        field: "email",
        sort: "asc",
        width: 200,
      },
      {
        label: "Phone",
        field: "phone",
        sort: "asc",
        width: 200,
      },
      {
        label: "Actions",
        field: "actions",
        width: 100,
      },
    ],

    rows: [...allStaff],
  }

  function registerStaff(values) {
    adminService.addStaff(values).then(res => {
      if (res.status) {
        setIsLoading(true)
        onSuccess()
      } else {
        onError(res.message)
      }
    })
  }

  function onError(msg) {
    setIsLoading(false)
    setRegistrationError(msg)
  }

  function onSuccess() {
    setIsLoading(false)
    setRegistrationSuccess("Registration successful!")
    setTimeout(() => {
      setRegistrationSuccess("")
    }, 8000)
    setRegistrationError("")
    setAddStaffModal(false)
  }

  function updateStaff(values) {
    adminService.updateStaff(values).then(res => {
      if (res.status) {
        onUpdateSuccess()
      } else {
        onUpdateError(res.message)
      }
    })
  }

  function onUpdateSuccess() {
    setIsLoadingUpdate(false)
    setUpdateSuccess("Update successful!")
    setTimeout(() => {
      setUpdateSuccess("")
    }, 8000)
    setUpdateError("")
  }

  function onUpdateError(msg) {
    setUpdateError(msg)
    setUpdateSuccess("")
  }

  function onClickUpdate(staffId) {
    adminService.getStaffDetails({ id: staffId }).then(res => {
      if (res.status) {
        setIndividualStaff(res.data)
        setMountUpdateModal(true)
        setUpdateStaffModal(true)
      }
    })
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Staff Directory</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            {registrationSuccess ? (
              <Alert color="success">{registrationSuccess}</Alert>
            ) : null}
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Staff Directory</h6>
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item active"></li>
                </ol>
              </Col>

              <Col md="4">
                <div className="float-end d-none d-md-block">
                  <Button
                    color="info"
                    className="btn btn-primary btn-block"
                    onClick={() => {
                      setAddStaffModal(true)
                    }}
                  >
                    Add Staff
                  </Button>
                </div>
              </Col>
            </Row>
          </div>

          <Row>
            <MDBDataTable responsive striped bordered data={data} />
          </Row>

          {mounted ? (
            <AddStaffModal
              show={addStaffModal}
              isLoading={isLoading}
              handleSubmit={registerStaff}
              onHide={() => {
                setIsLoading(false)
                setAddStaffModal(false)
              }}
              error={registrationError}
              departments={departments}
              positions={positions}
              permissions={permissions}
            />
          ) : (
            ""
          )}

          {mountUpdateModal ? (
            <UpdateStaffModal
              show={updateStaffModal}
              isLoading={isLoadingUpdate}
              handleSubmit={updateStaff}
              onHide={() => {
                setIsLoadingUpdate(false)
                setUpdateStaffModal(false)
              }}
              error={updateError}
              departments={departments}
              positions={positions}
              permissions={permissions}
              individualStaff={individualStaff}
              success={updateSuccess}
            />
          ) : (
            ""
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default StaffDirectory
